import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import DomPurify from "isomorphic-dompurify";
import { get } from "../../utils/get/get";
import styles from "./AEMContentFragmentWrapper.module.scss";
const { sanitize } = DomPurify;
export const ContentFragment = memo(({ data = {}, contentKey }) => {
    const fragmentData = useMemo(() => get(data, contentKey, ""), [data, contentKey]);
    return (_jsx(_Fragment, { children: _jsx("div", { className: styles.content, dangerouslySetInnerHTML: {
                __html: sanitize(fragmentData),
            } }) }));
});
//# sourceMappingURL=AEMContentFragmentWrapper.js.map